/*** ViewerLayout.js ***/
import React, { useState } from "react";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import { Layout, Menu, theme } from "antd";
import { AiOutlineDashboard } from "react-icons/ai";
import { IoIosNotifications } from "react-icons/io";
import { BiPowerOff, BiWalletAlt } from "react-icons/bi";
import { useNavigate, Outlet } from "react-router-dom";
import { loggedInUsers } from "../store/store";
import profilePic from "../assets/profile.png";
import CryptoJS from "crypto-js";
import { formatNumberAsCurrency } from "../libs/decrypt";
import { IoIosCreate } from "react-icons/io";
import { BsWalletFill } from "react-icons/bs";
import { MdOutlinePermPhoneMsg, MdViewList, MdMessage } from "react-icons/md";
import { BiMessageEdit } from "react-icons/bi";
import { FaSms, FaAddressBook, FaHistory } from "react-icons/fa";
import { SiGooglemessages } from "react-icons/si";
import { TbReport, TbReportAnalytics, TbFileReport } from "react-icons/tb";
import { FiSettings } from "react-icons/fi";

const { Header, Sider, Content } = Layout;

const ViewerLayout = () => {
  // get encrypted state from store
  const { userdata, akpaEgo } = loggedInUsers((state) => state.auth);

  // decrypt user data
  const decryptedUser = React.useMemo(() => {
    if (!userdata) return null;
    const bytes = CryptoJS.AES.decrypt(
      userdata,
      process.env.REACT_APP_SOCKET_ENCRYPTION_KEY
    );
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }, [userdata]);

  // decrypt wallet
  const wallet = React.useMemo(() => {
    if (!akpaEgo) return {};
    const bytes = CryptoJS.AES.decrypt(
      akpaEgo,
      process.env.REACT_APP_SOCKET_ENCRYPTION_KEY
    );
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  }, [akpaEgo]);

  const balance = formatNumberAsCurrency(wallet.balance);
  const [collapsed, setCollapsed] = useState(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const navigate = useNavigate();

  // Viewer menu items (exclude admin-only)
  const menuItems = [
    {
      key: "/viewer/dashboard",
      icon: <AiOutlineDashboard className="fs-4" />,
      label: "Dashboard",
    },
    

   
        {
          key: "/viewer/dashboard/sms-history",
          icon: <FaHistory className="fs-5" />,
          label: "SMS Details",
        },
        {
          key: "/viewer/dashboard/sms-report",
          icon: <TbReportAnalytics className="fs-5" />,
          label: "SMS Summary",
        },
        {
          key: "/viewer/dashboard/scheduled-report",
          icon: <TbFileReport className="fs-5" />,
          label: "Scheduled Report",
        },


    {
      key: "../auth/logout",
      icon: <BiPowerOff className="fs-4" />,
      label: "Logout",
    },
  ];

  return (
    <Layout>
      <Sider trigger={null} collapsible collapsed={collapsed}>
        <div className="logo">
          <h2 className="text-2xl text-center py-3 mb-0 font-semibold text-black">
            <span className="sm-logo">BBC</span>
            <span className="lg-logo">BroadBased</span>
          </h2>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={[window.location.pathname]}
          onClick={({ key }) => navigate(key)}
          items={menuItems}
        />
      </Sider>

      <Layout className="site-layout">
        <Header
          className="d-flex justify-between ps-1 pe-5 "
          style={{ padding: 0, background: colorBgContainer }}
        >
          {React.createElement(
            collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
            {
              className: "trigger",
              onClick: () => setCollapsed(!collapsed),
            }
          )}

          <div className="d-flex gap-4 items-center">
            {/* <div className="flex items-center">
              <h6 className="text-gray-900 mr-1 text-xl">
                <BsWalletFill />
              </h6>
              <p className="font-semibold text-sm">
                {wallet.currency} {balance}
              </p>
            </div> */}
            <div className="relative">
              <IoIosNotifications className="fs-4" />
              <span className="badge bg-warning rounded-xl p-1 absolute">
                0
              </span>
            </div>
            <div className="flex gap-2 items-center">
              <div>
                <img
                  className="object-cover h-9 w-9 rounded-lg"
                  src={profilePic}
                  alt=""
                ></img>
              </div>
              <div>
                <h5 className="leading-[20px] font-semibold text-gray-700 text-[14px] mb-0">
                  {`${decryptedUser.firstName} ${decryptedUser.lastName}`}
                </h5>
                <p className="leading-[10px] text-[11px] mb-0">
                  {decryptedUser.email}
                </p>
              </div>
            </div>
          </div>
        </Header>
        <Content
          style={{ margin: "24px", padding: 24, background: colorBgContainer }}
        >
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};

export default ViewerLayout;

/*** App.jsx Updates ***/

// 1) Import ViewerLayout at the top:
// import ViewerLayout from './components/ViewerLayout';

// 2) Inside <Routes> (after admin '/dashboard'):
// <Route path="/viewer/dashboard" element={
//   <AuthorizeUser>
//     <ViewerLayout />
//   </AuthorizeUser>
// }>
//   <Route index element={<Dashboard />} /> // or a viewer-specific home
//   <Route path="send-sms" element={<SendSMS />} />
//   <Route path="sms-history" element={<SMShistory />} />
// </Route>

/*** LoginNew.jsx Updates ***/

// In onSubmit success block, replace navigate(/dashboard) with:
// const user = authUser.data.data;
// if (user.role === 'viewer') {
//   navigate('/viewer/dashboard');
// } else {
//   navigate('/dashboard');
// }

/*** auth/middleware/auth.js Updates ***/

// Add helper to get full user object:
// export function getDecryptedUser() {
//   const { userdata } = loggedInUsers(state => state.auth);
//   if (!userdata) return null;
//   const bytes = CryptoJS.AES.decrypt(userdata, process.env.REACT_APP_SOCKET_ENCRYPTION_KEY);
//   return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
// }

// Update AuthorizeUser to ensure email exists:
// export function AuthorizeUser({ children }) {
//   const user = getDecryptedUser();
//   if (!user?.email) return <Navigate to='/' replace />;
//   return children;
// }

// (Old code has been commented out above rather than deleted to preserve admin logic.)
